module.exports = __webpack_public_path__ + "img/data-analytics.b8e467cb.svg";